import React from "react";

const StatsSection = () => {
  return (
    <section className="bg-green-100 py-12 px-6 md:px-16 lg:px-24">
      {/* Intro Text */}
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-gray-800 text-lg md:text-xl leading-relaxed">
          At <span className="font-semibold">Daily Go</span>, we’re reshaping the way businesses shop for bulk essentials—
          making it faster, smarter, and more cost-effective. With a growing
          network of trusted wholesale suppliers and a tech-powered platform, we
          deliver unbeatable daily deals on high-demand products.
        </p>
        <p className="mt-6 text-gray-800 text-lg md:text-xl leading-relaxed">
          Our focus is on reliability, speed, and savings—empowering retailers
          and resellers to stock confidently and grow consistently.
        </p>
      </div>

      {/* Stats Section */}
      <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-8 text-center max-w-5xl mx-auto">
        <div>
          <h3 className="text-2xl md:text-3xl font-bold text-green-900">2,000+</h3>
          <p className="text-gray-700 mt-2 text-sm md:text-base">Daily Deals Offered</p>
        </div>
        <div>
          <h3 className="text-2xl md:text-3xl font-bold text-green-900">500+</h3>
          <p className="text-gray-700 mt-2 text-sm md:text-base">Verified Sellers</p>
        </div>
        <div>
          <h3 className="text-2xl md:text-3xl font-bold text-green-900">1,000+</h3>
          <p className="text-gray-700 mt-2 text-sm md:text-base">Happy Buyers</p>
        </div>
        <div>
          <h3 className="text-2xl md:text-3xl font-bold text-green-900">85%</h3>
          <p className="text-gray-700 mt-2 text-sm md:text-base">Repeat Purchase Rate</p>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
